import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useTranslations } from '@/i18n/translations';
import { ErrorState } from '@leanin/ui';
import { RetryButton } from '@/components/states/index';
import { moderationKeys } from '@/lib/queries/moderation';
import { AutoHideNoticeView } from './-components/AutoHideNoticeView';

export const Route = createFileRoute(
  '/_authed/moderation/auto-hide-notice/$holdId/',
)({
  component: AutoHideNoticePage,
});

function AutoHideNoticePage() {
  const t = useTranslations('Moderation');
  const { holdId } = Route.useParams();
  const query = useQuery({
    ...moderationKeys.hold(holdId),
    retry: false,
  });

  if (query.isLoading) return null;
  if (query.isError) {
    const status = (query.error as { status?: number })?.status;
    const isNotFound = status === 404;
    return (
      <ErrorState
        title={t('autoHide.errorNotFoundTitle')}
        body={
          isNotFound
            ? t('autoHide.errorNotFoundBody')
            : t('autoHide.errorGenericBody')
        }
        reference={isNotFound ? 'http_404' : 'http_500'}
        {...(isNotFound ? {} : { primary: <RetryButton /> })}
      />
    );
  }
  return <AutoHideNoticeView holdId={holdId} />;
}
